import {pdsUtils} from './pds-utils';
import {pdsI18n} from './pds-i18n';
import {PopoverAccessibilityControllerIf} from './interfaces/popover-accessibility-controller-if';
import {TippyInstance} from './interfaces/tippy-instance';
export class PopoverAccessibilityController implements PopoverAccessibilityControllerIf {

  private currentPopoverTriggerElement: HTMLElement | undefined | null;
  private panelContainerElement: HTMLElement | undefined | null;
  private panelContainerTabInterceptFunction: (event: KeyboardEvent) => void;
  private hidePanelFunction: () => void | undefined;

  constructor() {

    // this function is required for accessibility to maintain a logical tab order.
    // since the popover gets appended to the end of the body, we lose logical tab order
    // as we tab from the popover trigger button to the contents of the popover, and out of the popover.

    this.panelContainerTabInterceptFunction = (event: KeyboardEvent) => {
      let allTabbableElementsInPopover = pdsUtils.getAllTabbableElements(<HTMLElement>this.panelContainerElement);
      if (event.keyCode === 9) {
        if (!event.shiftKey && event.target === allTabbableElementsInPopover[allTabbableElementsInPopover.length - 1]) {
          event.preventDefault();
          this.hidePanel();
          if (this.currentPopoverTriggerElement != null) {
            (<HTMLElement>this.currentPopoverTriggerElement).focus();
          }
        } else if (event.shiftKey && (event.target === this.panelContainerElement || event.target === allTabbableElementsInPopover[0])) {
          event.preventDefault();
          this.hidePanel();
          if (this.currentPopoverTriggerElement != null) {
            (<HTMLElement>this.currentPopoverTriggerElement).focus();
          }
        }
      }
    };
  }

  setPanelTrigger(trigger: HTMLElement | undefined | null): void {
    this.currentPopoverTriggerElement = trigger;
  }

  setPanelContainer(container: HTMLElement | undefined | null): void {
    this.panelContainerElement = container;
  }

  registerEventListenerOnPanel(eventType: string): void {
    if (this.panelContainerElement != null) {
      this.panelContainerElement.addEventListener(eventType, this.panelContainerTabInterceptFunction);
    }
  }

  deregisterEventListenerOnPanel(eventType: string): void {
    if (this.panelContainerElement != null) {
      this.panelContainerElement.removeEventListener(eventType, this.panelContainerTabInterceptFunction);
    }
  }

  setHidePanelCallback(aFunction: () => void): void {
    this.hidePanelFunction = aFunction;
  }

  addRequiredAccessibilityLabelsToChildTabbableElements(): void {
    let allTabableElementsInPopover: Array<HTMLElement> = [];
    if (this.panelContainerElement != null) {
      allTabableElementsInPopover = Array.prototype.slice.call(pdsUtils.getAllTabbableElements(this.panelContainerElement));
    }
    if (allTabableElementsInPopover.length >= 2) {
      let firstTabableElement = allTabableElementsInPopover[0];
      firstTabableElement.setAttribute('aria-label', firstTabableElement.innerText + '. ' + pdsI18n.getText('pds|popover|Backwards From First Element'));
      let lastTabableElement = allTabableElementsInPopover[allTabableElementsInPopover.length - 1];
      lastTabableElement.setAttribute('aria-label', lastTabableElement.innerText + '. ' + pdsI18n.getText('pds|popover|Forwards From Last Element'));
    } else if (allTabableElementsInPopover.length === 1) {
      let firstTabableElement = allTabableElementsInPopover[0];
      firstTabableElement.setAttribute('aria-label', firstTabableElement.innerText + '. ' + pdsI18n.getText('pds|popover|Navigating From Single Element'));
    }
  }

  private hidePanel(): void {
    if (this.hidePanelFunction != null) {
      this.hidePanelFunction();
    }
  }
}
